import { useEffect } from "react";

export default function DhlOptions({
  shippingAddress,
  setShippingAddress,
  checkMarks,
  setCheckMarks,
}) {
  /*   All States
   ********************************************* */

  /*   All Functions
   ********************************************* */

  /*   All UseEffects
   ********************************************* */

  useEffect(() => {
    if (shippingAddress) {
      setCheckMarks({
        signatureRelease: shippingAddress?.signatureRelease,
        selfCollect: shippingAddress?.selfCollect,
      });
    }
  }, []);

  return (
    <>
      {/* Remote Shipping */}
      <div className="row mb-1">
        <div className="flex-center justify-content-start col-5 pe-0">
          <label className="form-label">DHL Remote Address</label>
        </div>
        <div className="col-7 d-flex align-items-center justify-content-between gap-2x">
          <div className="d-flex me-2 ">
            <input
              type="text"
              className="form-control "
              disabled
              value={"Set from Api"}
            />
          </div>
          <div className="">
            <button type="button" className="btn text-nowrap btn-info">
              Validate Address
            </button>
          </div>
        </div>
      </div>

      {/* Signature Release  */}
      <div className="row mb-1">
        <div className="flex-center justify-content-start col-5 pe-0">
          <label className="form-label">DHL Signature Release</label>
        </div>
        <div className="col-7 d-flex">
          <input
            type="checkbox"
            checked={checkMarks?.signatureRelease}
            onChange={(e) => {
              setCheckMarks({
                selfCollect: !e.target.checked,
                signatureRelease: e.target.checked,
              });
            }}
            value={shippingAddress?.email || ""}
            id={"signatureRelease"}
            data-switch="success"
          />
          <label
            htmlFor={"signatureRelease"}
            data-on-label="Yes"
            data-off-label="No"
          ></label>
        </div>
      </div>

      {checkMarks.signatureRelease && (
        <div>
          {/* Authorize Person */}
          <div className="row mb-1">
            <div className="flex-center justify-content-start col-5 pe-0">
              <label className="form-label">DHL Authorize Person</label>
            </div>
            <div className="col-7 d-flex">
              <input
                value={shippingAddress?.authorizePerson || ""}
                onChange={(e) =>
                  setShippingAddress({
                    ...shippingAddress,
                    authorizePerson: e.target.value,
                  })
                }
                placeholder="Enter Authorize Person"
                type="text"
                className="form-control"
              />
            </div>
          </div>

          {/* Authorize Location */}
          <div className="row mb-1">
            <div className="flex-center justify-content-start col-5 pe-0">
              <label className="form-label">DHL Authorize Location</label>
            </div>
            <div className="col-7 d-flex">
              <input
                value={shippingAddress?.authorizeLocation || ""}
                onChange={(e) =>
                  setShippingAddress({
                    ...shippingAddress,
                    authorizeLocation: e.target.value,
                  })
                }
                placeholder="Enter Authorize location"
                type="text"
                className="form-control"
              />
            </div>
          </div>
        </div>
      )}

      {/* Self Collect  */}
      <div className="row mb-1">
        <div className="flex-center justify-content-start col-5 pe-0">
          <label className="form-label">DHL Self Collect</label>
        </div>
        <div className="col-7 d-flex">
          <input
            type="checkbox"
            checked={checkMarks?.selfCollect}
            onChange={(e) => {
              setCheckMarks({
                signatureRelease: !e.target.checked,
                selfCollect: e.target.checked,
              });
            }}
            id={"selfCollect"}
            data-switch="success"
          />
          <label
            htmlFor={"selfCollect"}
            data-on-label="Yes"
            data-off-label="No"
          ></label>
        </div>
      </div>

      <div className="row mb-1">
        <div className="flex-center justify-content-start col-5 pe-0">
          <label className="form-label">Service Center ID</label>
        </div>

        <div className="col-7 d-flex align-items-center justify-content-between gap-2">
          <input
            value={shippingAddress?.serviceId || ""}
            onChange={(e) =>
              setShippingAddress({
                ...shippingAddress,
                serviceId: e.target.value,
              })
            }
            placeholder="Enter Service ID"
            type="text"
            className="form-control"
          />
          <button type="button" className="btn btn-info text-nowrap">
            Service Point
          </button>
        </div>
      </div>
      <div className="row mb-1">
        <div className="flex-center justify-content-start col-5 pe-0">
          <label className="form-label">DHL Transit Time</label>
        </div>
        <div className="col-7">
          <input
            value={shippingAddress?.addressDhlTransitDays || ""}
            onChange={(e) =>
              setShippingAddress({
                ...shippingAddress,
                addressDhlTransitDays: e.target.value,
              })
            }
            placeholder="Enter DHL Transit Time"
            type="number"
            className="form-control"
          />
        </div>
      </div>
    </>
  );
}
